import React, { useEffect } from "react";
import { commonServices } from "../../../../api/services/commonServices";
import { useAppSelector } from "../../../../infra/hooks";

const DTOCurrentSalaryEditModal = () => {
  return <></>;
};
export default DTOCurrentSalaryEditModal;
